module.exports = __webpack_public_path__ + "static/media/andreAlen.6de0d54f.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/andreAlen.jpg
// module id = 1555
// module chunks = 1